<template>
  <div class="renzh">
    <div class="manage" v-show="type == 1">
      <div class="top-box">
        <div class="flexrbc">
          <div class="flexr0c">
            <div class="title-label"></div>
            <div class="title">客户管理</div>
          </div>
          <div class="flexr0c">
            <div class="addOrg-red flexrcc" @click="refund">
              <div class="btn">退款</div>
            </div>
            <div class="addOrg flexrcc" @click="batchManage">
              <div class="btn">批量管理</div>
            </div>
            <div class="addOrg flexrcc" @click="addUser" style="margin-left: 10px">
              <img src="../../assets/imgs/home/add.png" alt />
              <div class="btn">新增客户</div>
            </div>
          </div>
        </div>
      </div>
      <div class="search-box flexr0c">
        <div class="input">
          <Input v-model="keyword" placeholder="请输入需要查询的内容" size="large" style="width: auto">
          <Icon type="ios-search" slot="suffix" />
          </Input>
        </div>
        <div class="btn" @click="getPage(1, keyword)">查询</div>
      </div>
      <div class="table-box">
        <div class="table">
          <Table max-height="" ref="selection" @on-select="chooseTable" @on-select-all="chooseTable" @on-select-all-cancel="chooseTable" @on-select-cancel="chooseTable" :loading="loading1" border stripe :columns="tableHead" :data="tableData">
            <template class="flexr0c" slot-scope="{ row, index }" slot="action">
              <div class="flexr0c icon-box" @mouseenter="hover(index)">
                <div @click="look(index)">
                  <div class="iconfont" @mouseenter="tip1 = true" @mouseleave="tip1 = false">&#xe604;</div>
                  <div class="tips" v-show="tip1 && hoverIndex == index">查看</div>
                </div>
                <div @click="edit(index)">
                  <div class="iconfont" @mouseenter="tip2 = true" @mouseleave="tip2 = false">&#xe601;</div>
                  <div class="tips" v-show="tip2 && hoverIndex == index">编辑</div>
                </div>
                <div @click="log(index)">
                  <div class="iconfont" @mouseenter="tip3 = true" @mouseleave="tip3 = false">&#xe602;</div>
                  <div class="tips tips2" v-show="tip3 && hoverIndex == index">日志</div>
                </div>
                <div @click="del(index)">
                  <div class="iconfont" @mouseenter="tip4 = true" @mouseleave="tip4 = false">&#xe603;</div>
                  <div class="tips tips2" v-show="tip4 && hoverIndex == index">删除</div>
                </div>
              </div>
            </template>
          </Table>
          <div style="margin: 10px; overflow: hidden">
            <div style="float: right">
              <Page :total="total" :page-size="pageSize" :current="1" @on-change="changePage" show-elevator show-total> </Page>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="item" v-show="type == 2">
      <div class="top flexr0c">
        <img class="addr" src="../../assets/imgs/home/location.png" alt="" />
        <div class="title" @click="manage">客户管理</div>
        <img class="arrow" src="../../assets/imgs/home/rightarrow.png" alt="" />
        <div class="title">{{ msg }}</div>
      </div>
      <div class="content">
        <div class="input-box flexrbc">
          <div class="flexc0s">
            <div class="flexr0c">
              <div class="star">*</div>
              <div class="label">客户手机号</div>
            </div>
            <Input class="adduser" type="" maxlength="11" v-if="msg == '新增客户'" @on-blur="search" v-model="phone" type="text" @on-input="value = value.replace(/[^\d]/g, '')" />
            <input v-if="msg !== '新增客户'" disabled v-model="phone" type="text" oninput="value=value.replace(/[^\d]/g,'')" />
          </div>
          <div class="flexc0s">
            <div class="label">客户名称</div>
            <input disabled type="text" :value="buyerName" />
          </div>
        </div>
        <div class="split-line"></div>
        <div v-if="!islog">
          <div class="org-info">
            <div class="top flexrbc">
              <div class="flexr0c">
                <div class="label"></div>
                <div class="title">矿种信息</div>
                <div class="subtitle">(说明：强制预存支付客户无余额不能现场支付)</div>
              </div>
              <div class="btn-box flexrcc" v-if="lookType != 1" @click="addOrg">
                <img src="../../assets/imgs/home/add.png" alt />
                <div class="btn">新增矿种</div>
              </div>
            </div>
            <Table max-height="185" border stripe :columns="oreTableHead" :data="oreTableData">
              <template class="flexr0c" slot-scope="{ row, index }" slot="action">
                <div class="flexr0c">
                  <div class="flexr0c icon-box">
                    <div class="flexr0c" v-if="lookType != 1" @click="editOrg(index)">
                      <div class="iconfont edit-icon">&#xe601;</div>
                      <div class="eidt" style="margin-right: 10px">编辑</div>
                    </div>
                  </div>
                  <div class="flexr0c icon-box">
                    <div class="flexr0c" @click="delOrg2(index)" v-if="lookType != 1">
                      <div class="iconfont del-icon">&#xe603;</div>
                      <div class="del">删除</div>
                    </div>
                  </div>
                </div>
              </template>
            </Table>
          </div>
          <div class="org-info" style="margin-top: 32px">
            <div class="top flexrbc">
              <div class="flexr0c">
                <div class="label"></div>
                <div class="title">银行账户</div>
                <div class="subtitle">(说明：请注意进行企业充值验证，避免绑定银行账户错误！)</div>
              </div>
              <div class="btn-box flexrcc" @click="addBank" v-if="lookType != 1">
                <img src="../../assets/imgs/home/add.png" alt />
                <div class="btn">新增账户</div>
              </div>
            </div>
            <Table max-height="185" border stripe :columns="bankTableHead" :data="bankTableData">
              <template class="flexr0c" slot-scope="{ row, index }" slot="action">
                <div class="flexr0c icon-box">
                  <div class="flexr0c" @click="delBank(index)" v-if="lookType != 1">
                    <div class="iconfont del-icon">&#xe603;</div>
                    <div class="del">删除</div>
                  </div>
                </div>
              </template>
            </Table>
          </div>
          <div class="remark-box" v-if="lookType != 1">
            <div class="label">备注</div>
            <Input v-model="remark" maxlength="50" show-word-limit type="textarea" placeholder="" style="width: 860px" />
          </div>
          <div class="remark-box" v-else>
            <div class="label">备注</div>
            <Input v-model="remark" maxlength="50" type="textarea" disabled placeholder="" style="width: 860px" />
          </div>
          <div class="bottom-btn-box flexrcc" v-if="lookType != 1">
            <div class="cancel" @click="cancel4">取消</div>
            <button :loading="subLoading" class="save" @click="save4">保存</button>
          </div>
        </div>
        <div v-if="islog" style="padding-bottom: 20px;">
          <div class="flexr0c filter">
            <div class="label">维护日期</div>
            <Row>
              <Col span="12">
              <DatePicker :value="value2" format="yyyy/MM/dd" type="daterange" placement="bottom-end" placeholder="选择日期" style="width: 240px" @on-change="handleChange"></DatePicker>
              </Col>
            </Row>
            <div class="label">修改项目</div>
            <Select v-model="select1" style="width: 140px" @on-change="handleLog">
              <Option v-for="(item, index) in proList" :value="item.value" :key="index">{{ item.value }}</Option>
            </Select>
          </div>
          <Table border stripe :columns="select1 == '矿种日志'? logHead : logHead2" :data="logData"> </Table>
          <div style="margin: 10px; overflow: hidden">
            <div style="float: right">
              <Page :total="logCount" :current="pageIndex" :page-size="pageSize" @on-change="changePage1" show-elevator show-total> </Page>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="mask" v-if="model1 || model2 || model3 || model4 || model5">
      <div v-if="model1" class="pop1-box">
        <div class="top flexrcc">
          <div class="title">{{ popmsg }}</div>
          <img @click="model1 = 0" src="../../assets/imgs/home/close.png" alt />
        </div>
        <div class="content">
          <div class="item flexc0s">
            <div class="title-box flexr0c">
              <span>*</span>
              <div class="title">矿种名称</div>
            </div>
            <Select v-model="select2" style="width: 368px">
              <Option v-for="(item, index) in oreList" :value="item.oreId + '/' + item.oreName" :key="index"> {{ item.oreName }}</Option>
            </Select>
            <!-- <div>
                        <div class="title-box flexr0c">
                            <span>*</span>
                            <div class="title">强制预付支付</div>
                            <RadioGroup v-model="disabledGroup1">
                                <Radio label="是"></Radio>
                                <Radio label="否"></Radio>
                            </RadioGroup>
                        </div>
                        <div class="explain">(说明：强制预存支付客户无余额不能现场支付)</div>
                    </div>-->
            <!-- <div class="title-box flexr0c">
              <span>*</span>
              <div class="title">是否优惠</div>
              <RadioGroup v-model="disabledGroup2" @on-change="radioChange">
                <Radio label="是"></Radio>
                <Radio label="否"></Radio>
              </RadioGroup>
            </div> -->
            <div class="title-box flexr0c">
              <span></span>
              <div class="title">优惠价格</div>
            </div>
            <div class="flexr0c">
              <input v-if="!disCount" disabled type="text" maxlength="20" v-model="discountPrice" class="price-input" oninput="value=value.replace(/[^\d]/g,'')" />
              <Input v-if="disCount" type="text" maxlength="20" v-model="discountPrice" class="price-input" @on-input="value = value.replace(/[^\d]/g, '')" />
              <div class="unit">元/吨</div>
            </div>
          </div>
        </div>
        <div class="bottom flexrcc">
          <div class="cancel" @click="model1 = false">取消</div>
          <div class="save" v-if="model1 == 1" @click="save1">保存</div>
          <div class="save" v-if="model1 == 2" @click="save12">保存</div>
        </div>
      </div>
      <div v-if="model2" class="pop2-box">
        <div class="top flexrcc">
          <div class="title">提示</div>
          <img @click="model2 = false" src="../../assets/imgs/home/close.png" alt />
        </div>
        <div class="content flexccc" v-if="tip == 2">确定删除此银行账户吗？</div>
        <div class="content flexccc" v-if="tip == 3">确定删除此矿种吗？</div>
        <div class="content flexccc" v-if="tip == 1">{{ accName }}绑定了此银行账号！</div>
        <div class="bottom flexrcc" v-if="tip == 2">
          <div class="save" @click="save2">确定</div>
          <div class="cancel" @click="model2 = false">取消</div>
        </div>
        <div class="bottom flexrcc" v-if="tip == 3">
          <div class="save" @click="delOrg">确定</div>
          <div class="cancel" @click="model2 = false">取消</div>
        </div>
        <div class="bottom flexccc" v-if="tip == 1">
          <div class="save" @click="tipsComfirm">确定</div>
        </div>
      </div>
      <div v-if="model3" class="pop3-box">
        <div class="top flexrcc">
          <div class="title">新增账户</div>
          <img @click="model3 = false" src="../../assets/imgs/home/close.png" alt />
        </div>
        <div class="content">
          <div class="item">
            <div class="title-box flexr0c">
              <span>*</span>
              <div class="title">银行名称</div>
            </div>
            <Select class="bank-select" v-model="select3" filterable style="width: 368px">
              <Option v-for="(item, index) in bankList" :value="item.id + '/' + item.bankName" :key="index"> {{ item.bankName }}</Option>
            </Select>
            <div class="title-box flexr0c">
              <span>*</span>
              <div class="title">银行账号</div>
            </div>
            <Input type="text" placeholder="请输入银行账号" class="name-input" v-model="bankAcc" @on-input="value = value.replace(/[^\d]/g, '')" />
            <div class="title-box flexr0c">
              <span>*</span>
              <div class="title">账户名称</div>
            </div>
            <Input type="text" placeholder="请输入账户名称" class="name-input" v-model="accName" />
          </div>
        </div>
        <div class="bottom flexrcc">
          <div class="cancel" @click="model3 = false">取消</div>
          <div class="save" @click="save3">保存</div>
        </div>
      </div>
      <div v-if="model4" class="pop1-box">
        <div class="top flexrcc">
          <div class="title">批量管理</div>
          <img @click="model4 = false" src="../../assets/imgs/home/close.png" alt />
        </div>
        <div class="content">
          <div class="item flexc0s">
            <div class="title-box flexr0c">
              <span>*</span>
              <div class="title">矿种名称</div>
            </div>
            <Select v-model="select2" style="width: 368px">
              <Option v-for="(item, index) in oreList" :value="item.oreId + '/' + item.oreName" :key="index"> {{ item.oreName }}</Option>
            </Select>
            <!-- <div class="title-box flexr0c">
              <span>*</span>
              <div class="title">是否优惠</div>
              <RadioGroup v-model="disabledGroup2" @on-change="radioChange">
                <Radio label="是"></Radio>
                <Radio label="否"></Radio>
              </RadioGroup>
            </div> -->
            <div class="title-box flexr0c">
              <span></span>
              <div class="title">优惠价格</div>
            </div>
            <div class="flexr0c">
              <input v-if="!disCount" disabled type="text" maxlength="20" v-model="discountPrice" class="price-input" oninput="value=value.replace(/[^\d]/g,'')" />
              <Input v-if="disCount" type="text" maxlength="20" v-model="discountPrice" class="price-input" @on-input="value = value.replace(/[^\d]/g, '')" />
              <div class="unit">元/吨</div>
            </div>
          </div>
        </div>
        <div class="bottom flexrcc">
          <div class="cancel" @click="
              model1 = false;
              model4 = false;
            ">
            取消
          </div>
          <div class="save" v-if="model1 == 1" @click="save1">保存</div>
          <div class="save" v-if="model1 == 2" @click="save12">保存</div>
          <div class="save" v-if="model4 == true" @click="saveBatch">保存</div>
        </div>
      </div>
      <div v-if="model5" class="pop1-box">
        <div class="top flexrcc">
          <div class="title">退款</div>
          <img @click="model5 = false" src="../../assets/imgs/home/close.png" alt />
        </div>
        <div class="question-content">
          确定退款吗？
        </div>
        <div class="bottom flexrcc">
          <div class="cancel" @click="model5 = false">
            取消
          </div>
          <div class="save" @click="refundConfirm">确认</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'userManage',
  data () {
    return {
      type: 1,
      msg: '新增客户',
      islog: true,
      hoverIndex: -1,
      keyword: '',
      subLoading: false,
      model1: false,
      model2: false,
      model3: false,
      model4: false,
      model5: false,
      tip1: false,
      tip2: false,
      tip3: false,
      tip4: false,
      select1: '矿种日志',
      select2: '',
      select3: '',
      total: 100,
      pageSize: 7,
      loading1: true,
      phone: '',
      index: -1, //当前选中的index
      popmsg: '新增矿种',
      value2: [],
      disabledGroup1: '是',
      disabledGroup2: '是',
      tableSelection: [], //表格选中的项目
      tableHead: [
        {
          type: 'selection',
          width: 60,
          align: 'center'
        },
        {
          title: '客户名称',
          key: 'buyerName',
          width: 170,
          resizable: true
        },
        {
          title: '手机号',
          key: 'buyerPhone',
          width: 130,
          resizable: true
        },
        {
          title: '累计充值(元)',
          key: 'totalInMoney',
          width: 130,
          resizable: true
        },
        {
          title: '累计消费(元)',
          key: 'totalOutMoney',
          width: 130,
          resizable: true
        },
        {
          title: '当前余额(元)',
          key: 'balance',
          width: 130,
          resizable: true
        },
        {
          title: '备注',
          key: 'remark',
          width: 150,
          resizable: true,
          render: (h, params) => {
            if (params.row.remark && params.row.remark.length > 10) {
              return h('div', [
                h(
                  'Tooltip',
                  {
                    props: {
                      transfer: true,
                      theme: 'light'
                    }
                  },
                  [
                    h(
                      'span',
                      {
                        style: {
                          display: 'inline-block',
                          width: params.column._width * 0.9 + 'px',
                          overflow: 'hidden',
                          textOverflow: 'ellipsis',
                          whiteSpace: 'nowrap'
                        }
                      },
                      params.row.remark
                    ),
                    h(
                      'span',
                      {
                        slot: 'content',
                        style: { whiteSpace: 'normal', wordBreak: 'break-all' }
                      },
                      params.row.remark
                    )
                  ]
                )
              ]);
            } else {
              return h('span', {}, params.row.remark);
            }
          }
        },
        {
          title: '维护人',
          key: 'createUserName',
          width: 180,
          resizable: true
        },
        {
          title: '维护日期',
          key: 'createTime',
          width: 170,
          resizable: true
        },
        {
          title: '操作',
          slot: 'action',
          width: 130,
          align: 'left',
          fixed: 'right',
          resizable: true
        }
      ],
      tableData: [],
      oreTableHead: [
        {
          title: '矿种名称',
          key: 'oreName',
          width: 230,
          resizable: true
        },
        {
          title: '强制预存支付',
          key: 'isPrePay',
          width: 150,
          resizable: true
        },
        {
          title: '是否优惠',
          key: 'isDiscount',
          width: 135,
          resizable: true
        },
        {
          title: '优惠价格(元/吨)',
          key: 'discountPrice',
          resizable: true
        },
        {
          title: '操作',
          slot: 'action',
          align: 'left',
          width: 150,
          resizable: true
        }
      ],
      oreTableData: [],
      oreTableData2: [],
      bankTableHead: [
        {
          title: '银行名称',
          key: 'bankName',
          width: 250,
          resizable: true
        },
        {
          title: '账户名称',
          key: 'accountName',
          width: 250,
          resizable: true
        },
        {
          title: '银行账号',
          key: 'accountNo',
          // width: 365,
          resizable: true
        },
        {
          title: '操作',
          slot: 'action',
          align: 'left',
          width: 95,
          resizable: true
        }
      ],
      bankTableData: [],
      bankTableData2: [],
      logHead: [
        {
          title: '修改项目',
          key: 'oreName'
        },
        {
          title: '维护时间',
          key: 'updateTime',
          width: 200
        },
        {
          title: '维护人',
          key: 'updateUserName',
          width: 180
        },
        {
          title: '旧值',
          key: 'oldValue',
          width: 180
        },
        {
          title: '新值',
          key: 'newValue',
          width: 180
        }
      ],
      logHead2: [
        {
          title: '修改项目',
          key: 'fieldDesc'
        },
        {
          title: '维护时间',
          key: 'createTimeStr',
          width: 200
        },
        {
          title: '维护人',
          key: 'buyerPhone',
          width: 180
        },
        {
          title: '旧值',
          key: 'beforeChangeDesc',
          width: 180
        },
        {
          title: '新值',
          key: 'afterChangeDesc',
          width: 180
        }
      ],
      logCount: 0,
      pageIndex: 1,
      logData: [],
      bankList: [],
      oreList: [],
      proList: [
        {
          value: '矿种日志',
          label: '矿种日志'
        },
        {
          value: '基础日志',
          label: '基础日志'
        }
      ],
      remark: '',
      id: '',
      discountPrice: '',
      bankAcc: '',
      accName: '',
      tip: -1,
      buyerName: '',
      lookType: -1,
      disCount: true
    };
  },
  methods: {
    isPoneAvailable (poneInput) {
      var myreg = /^[1][3,4,5,6,7,8,9][0-9]{9}$/;
      if (!myreg.test(poneInput)) {
        return false;
      } else {
        return true;
      }
    },
    dateFormat (fmt, date) {
      let ret;
      const opt = {
        'Y+': date.getFullYear().toString(), // 年
        'm+': (date.getMonth() + 1).toString(), // 月
        'd+': date.getDate().toString(), // 日
        'H+': date.getHours().toString(), // 时
        'M+': date.getMinutes().toString(), // 分
        'S+': date.getSeconds().toString() // 秒
        // 有其他格式化字符需求可以继续添加，必须转化成字符串
      };
      for (let k in opt) {
        ret = new RegExp('(' + k + ')').exec(fmt);
        if (ret) {
          fmt = fmt.replace(ret[1], ret[1].length == 1 ? opt[k] : opt[k].padStart(ret[1].length, '0'));
        }
      }
      return fmt;
    },
    radioChange (value) {
      value == '是' ? (this.disCount = true) : (this.disCount = false);
      value == '否' ? (this.discountPrice = '') : this.disCount;
    },
    hover (index) {
      this.hoverIndex = index;
    },
    addUser () {
      this.type = 2;
      this.lookType = 2;
      this.islog = false;
      this.msg = '新增客户';
      this.oreTableData = [];
      this.oreTableData2 = [];
      this.bankTableData = [];
      this.bankTableData2 = [];
      this.buyerName = '';
      this.remark = '';
      this.id = '';
    },
    addOrg () {
      // this.getSelect()
      this.model1 = 1;
      this.select2 = '';
      this.discountPrice = '';
      this.popmsg = '新增矿种';
      this.disabledGroup2 == '是' ? (this.disCount = true) : this.disCount;
    },
    editOrg (index) {
      this.select2 = this.oreTableData[index].oreId + '/' + this.oreTableData[index].oreName;
      this.index = index;
      this.popmsg = '编辑矿种';
      this.disabledGroup1 = this.oreTableData[index].isPrePay;
      this.disabledGroup2 = this.oreTableData[index].isDiscount;
      this.disabledGroup2 == '是' ? (this.discountPrice = this.oreTableData[index].discountPrice) : (this.discountPrice = '');
      this.disabledGroup2 == '是' ? (this.disCount = true) : (this.disCount = false);
      this.model1 = 2;
    },
    addBank () {
      this.getBankSelect();
      this.model3 = true;
      this.popmsg = '新增账户';
    },
    look (index) {
      this.lookType = 1;
      this.id = this.tableData[index].id;
      this.getItemInfo(index);
      this.islog = false;
      this.msg = '查看客户';
      this.type = 2;
    },
    edit (index) {
      this.lookType = 3;
      this.id = this.tableData[index].id;
      this.getItemInfo(index);
      this.islog = false;
      this.msg = '编辑客户';
      this.type = 2;
    },
    log (index) {
      this.index = index;
      this.getItemInfo(index);
      this.getLogInfo(1);
      this.islog = true;
      this.msg = '日志';
      this.type = 2;
    },
    del (index) {
      this.index = index;
      this.islog = false;
      this.msg = '删除';
      let session = JSON.parse(localStorage['session']);
      let data = {
        sessionId: session.sessionId,
        userId: session.userId,
        modeCode: 'vuWasb5jipaBmVx5GO5nf4CIfY6b6xT4',
        id: this.tableData[index].id
      };
      this.$http.post(data).then((res) => {
        if (res.code == 1) {
          this.tableData.splice(index, 1);
        } else {
          this.$Message['error']({
            background: true,
            content: res.msg
          });
        }
      });
    },
    changePage (page) {
      this.getPage(page);
    },
    changePage1 (page) {
      if (this.select1 == '矿种日志') {
        this.getLogInfo(page);
      } else {
        this.getLogInfo2(page);
      }
    },
    manage () {
      this.type = 1;
      this.islog = false;
      this.phone = '';
      this.select1 = "矿种日志";
      this.getPage(1);
    },
    //退款
    refund () {
      if (this.tableSelection.length == 0) {
        this.$Message['error']({
          background: true,
          content: '请先选择表格项'
        });
        return;
      } else if (this.tableSelection.length > 1) {
        this.$Message['error']({
          background: true,
          content: '退款只能选择一项'
        });
      } else {
        this.model5 = true;
      }
    },
    refundConfirm () {
      let session = JSON.parse(localStorage['session']);
      let data = {
        modeCode: 'Y9uK2rE7meH4yawnFWiF6nTPuuGaXozu',
        sessionId: session.sessionId,
        userId: session.userId,
        buyerId: this.tableSelection[0].buyerId
      };
      this.$http.post(data).then((res) => {
        if (res.code == 1) {
          this.model5 = false;
          this.getPage(1);
          this.$Message['success']({
            background: true,
            content: res.msg
          });
        } else {
          this.model5 = false;
          this.$Message['error']({
            background: true,
            content: res.msg
          });
        }
      });
    },
    //触发批量管理弹出
    batchManage () {
      if (this.tableSelection.length == 0) {
        this.$Message['error']({
          background: true,
          content: '请先选择表格项'
        });
        return;
      }
      this.model4 = true;
    },
    //table选择的事件
    chooseTable (selection) {
      this.tableSelection = selection;
    },
    delOrg () {
      this.oreTableData2[this.index].state = 1;
      this.oreTableData2[this.index].delTime = this.dateFormat('YYYY-mm-dd HH:MM:SS', new Date());
      this.oreTableData.splice(this.index, 1);
      this.oreTableData2.splice(this.index, 1);
      this.model2 = false;
    },
    delBank (index) {
      this.model2 = true;
      this.index = index;
      this.tip = 2;
    },
    delOrg2 (index) {
      this.model2 = true;
      this.index = index;
      this.tip = 3;
    },
    save1 () {
      let obj = {
        oreId: this.select2.split('/')[0],
        oreName: this.select2.split('/')[1],
        isPrePay: this.disabledGroup1,
        isDiscount: this.disabledGroup2,
        discountPrice: this.discountPrice,
        state: 0,
        createTime: this.dateFormat('YYYY-mm-dd HH:MM:SS', new Date()),
        delTime: this.dateFormat('YYYY-mm-dd HH:MM:SS', new Date())
      };
      let obj2 = {
        oreId: this.select2.split('/')[0],
        oreName: this.select2.split('/')[1],
        isPrePay: this.disabledGroup1 == '是' ? 1 : 0,
        isDiscount: this.disabledGroup2 == '是' ? 1 : 0,
        discountPrice: this.discountPrice,
        state: 0,
        createTime: this.dateFormat('YYYY-mm-dd HH:MM:SS', new Date()),
        delTime: this.dateFormat('YYYY-mm-dd HH:MM:SS', new Date())
      };
      let hadAdd = false;
      this.oreTableData.forEach((item) => {
        if (item.oreName == this.select2.split('/')[1]) {
          this.$Message['error']({
            background: true,
            content: '矿种已添加'
          });
          hadAdd = true;
        }
      });
      if (hadAdd) {
        return;
      }
      if (this.select2 == '') {
        this.$Message['error']({
          background: true,
          content: '请选择矿种'
        });
        return;
      }
      if (this.disabledGroup2 == '是' && this.discountPrice == '') {
        this.$Message['error']({
          background: true,
          content: '请输入优惠价格'
        });
        return;
      }
      this.oreTableData.push(obj);
      this.oreTableData2.push(obj2);
      this.model1 = 0;
    },
    save12 () {
      if (!this.select2) {
        this.$Message['error']({
          background: true,
          content: '请选择矿种'
        });
        return;
      }
      if (this.disabledGroup2 == '是' && this.discountPrice == '') {
        this.$Message['error']({
          background: true,
          content: '请输入优惠价格'
        });
        return;
      }
      this.oreTableData[this.index].oreId = this.select2.split('/')[0];
      this.oreTableData[this.index].oreName = this.select2.split('/')[1];
      this.oreTableData[this.index].isPrePay = this.disabledGroup1;
      this.oreTableData[this.index].isDiscount = this.disabledGroup2;
      this.oreTableData[this.index].discountPrice = this.discountPrice;
      this.oreTableData2[this.index].oreId = this.select2.split('/')[0];
      this.oreTableData2[this.index].oreName = this.select2.split('/')[1];
      this.oreTableData2[this.index].isPrePay = this.disabledGroup1 == '是' ? 1 : 0;
      this.oreTableData2[this.index].isDiscount = this.disabledGroup2 == '是' ? 1 : 0;
      this.oreTableData2[this.index].discountPrice = this.discountPrice;
      this.model1 = 0;
    },
    save2 () {
      this.model1 = 0;
      this.bankTableData2[this.index].state = 1;
      this.bankTableData2[this.index].delTime = this.dateFormat('YYYY-mm-dd HH:MM:SS', new Date());
      this.bankTableData.splice(this.index, 1);
      this.bankTableData2.splice(this.index, 1);
      this.model2 = false;
      this.tip = 2;
    },
    save3 () {
      let obj = {
        bankName: this.select3.split('/')[1],
        accountNo: this.bankAcc,
        accountName: this.accName,
        state: 0,
        createTime: this.dateFormat('YYYY-mm-dd HH:MM:SS', new Date()),
        delTime: this.dateFormat('YYYY-mm-dd HH:MM:SS', new Date()),
        a: 0
      };
      let obj2 = {
        bankName: this.select3.split('/')[1],
        accountNo: this.bankAcc,
        accountName: this.accName,
        state: 0,
        createTime: this.dateFormat('YYYY-mm-dd HH:MM:SS', new Date()),
        delTime: this.dateFormat('YYYY-mm-dd HH:MM:SS', new Date())
      };
      if (!this.select3) {
        this.$Message['error']({
          background: true,
          content: '请选择银行名称'
        });
        return;
      }
      if (!this.bankAcc) {
        this.$Message['error']({
          background: true,
          content: '请输入银行账号'
        });
        return;
      }
      if (!this.accName) {
        this.$Message['error']({
          background: true,
          content: '请输入账户名称'
        });
        return;
      }
      this.bankTableData.push(obj);
      this.bankTableData2.push(obj2);
      this.model3 = false;
      this.tip = 1;
      this.model2 = true;
    },
    save4 () {
      if (!this.phone) {
        this.$Message['error']({
          background: true,
          content: '请输入客户手机号'
        });
        return;
      }
      if (!this.id) {
        this.$Message['error']({
          background: true,
          content: '未找到客户信息'
        });
        return;
      }
      // if (this.oreTableData2.length == 0) {
      //     this.$Message['error']({
      //         background: true,
      //         content: "请先添加矿种"
      //     });
      //     return
      // }
      if (this.bankTableData2.length == 0) {
        this.$Message['error']({
          background: true,
          content: '请先添加银行账户'
        });
        return;
      }
      this.lookType == 2 ? this.addUserInfo() : this.editUserInfo();
    },
    //批量管理保存
    saveBatch () {
      let id = this.tableSelection.map((item) => {
        return item.id;
      });
      let ids = id.join();
      let session = JSON.parse(localStorage['session']);
      let isDiscount = this.disabledGroup2 == '是' ? 1 : 0;
      let data = {
        sessionId: session.sessionId,
        userId: session.userId,
        crmIds: ids,
        oreId: this.select2.split('/')[0],
        oreName: this.select2.split('/')[1],
        isPrePay: 1,
        isDiscount: isDiscount,
        discountPrice: this.discountPrice,
        modeCode: 'SPUT2PxB3k9Vn2P0oFhVkFYKOq4LDHR5'
      };
      this.$http.post(data).then((res) => {
        if (res.code == 1) {
          this.model4 = false;
          this.discountPrice = '';
          this.select2 = '';
          this.disabledGroup2 = '是';
        } else {
          this.$Message['error']({
            background: true,
            content: res.msg
          });
        }
      });
    },
    cancel4 () {
      this.oreTableData = [];
      this.bankTableData = [];
      this.manage();
    },
    tipsComfirm () {
      this.select3 = '';
      this.bankAcc = '';
      this.accName = '';
      this.model2 = false;
    },
    cancel1 () {
      this.model1 = 0;
    },
    getSelect () {
      var session = JSON.parse(localStorage['session']);
      let data = {
        sessionId: session.sessionId,
        userId: session.userId,
        modeCode: 'o7ZDsmbWylX4R9aKzK4CW76AeUcEGIkU'
      };
      this.$http.post(data).then((res) => {
        if (res.code == 1) {
          this.oreList = res.data.oreList;
        } else {
          this.$Message['error']({
            background: true,
            content: res.msg
          });
        }
      });
    },
    getBankSelect () {
      var session = JSON.parse(localStorage['session']);
      let data = {
        sessionId: session.sessionId,
        userId: session.userId,
        modeCode: 'G8u8zy69OyBffUtGNsVmyT6ebGnt4H0K'
      };
      this.$http.post(data).then((res) => {
        if (res.code == 1) {
          this.bankList = res.data.bankList;
        } else {
          this.$Message['error']({
            background: true,
            content: res.msg
          });
        }
      });
    },
    handleLog () {
      if (this.select1 == '矿种日志') {
        this.getLogInfo(1);
      } else {
        this.getLogInfo2(1);
      }
    },
    getLogInfo (page) {
      const session = JSON.parse(localStorage['session']);
      let data = {
        sessionId: session.sessionId,
        userId: session.userId,
        modeCode: 'Ph3DXoZGXZKwigIA2ijX1mnUeGv9AW4Z',
        crmId: this.tableData[this.index].id,
        pageSize: this.pageSize,
        pageIndex: page
      };
      if (this.value2.length != 0) {
        data.startDate = this.value2[0].replace(/\//g, '-');
        data.endDate = this.value2[1].replace(/\//g, '-');
      }
      this.$http.post(data).then((res) => {
        if (res.code == 1) {
          this.logCount = res.data.count;
          this.logData = res.data.list;
        } else {
          this.$Message['error']({
            background: true,
            content: res.msg
          });
        }
      });
    },
    getLogInfo2 (page) {
      const session = JSON.parse(localStorage['session']);
      let data = {
        sessionId: session.sessionId,
        userId: session.userId,
        modeCode: '1oQB0qpNu602U6W1Ak6TzUA2iHJ4Th6z',
        dataId: this.tableData[this.index].buyerId,
        pageSize: this.pageSize,
        pageIndex: page
      };
      if (this.value2.length != 0) {
        data.startDate = this.value2[0].replace(/\//g, '-');
        data.endDate = this.value2[1].replace(/\//g, '-');
      }
      this.$http.post(data).then((res) => {
        if (res.code == 1) {
          this.logCount = res.data.count;
          this.logData = res.data.list;
        } else {
          this.$Message['error']({
            background: true,
            content: res.msg
          });
        }
      });
    },
    getItemInfo (index) {
      var session = JSON.parse(localStorage['session']);
      let data = {
        sessionId: session.sessionId,
        userId: session.userId,
        modeCode: 'rl9JepG7GPMZjJIQk8ZK4e6bWS5d52BH',
        id: this.tableData[index].id
      };
      this.$http.post(data).then((res) => {
        if (res.code == 1) {
          this.buyerName = res.data.byuerName;
          this.phone = res.data.buyerPhone;
          let list = JSON.parse(JSON.stringify(res.data.crmOreList));
          list.forEach((item) => {
            item.isDiscount == 1 ? (item.isDiscount = '是') : (item.isDiscount = '否');
            item.isPrePay == 1 ? (item.isPrePay = '是') : (item.isPrePay = '否');
          });
          this.oreTableData = list;
          this.oreTableData2 = JSON.parse(JSON.stringify(res.data.crmOreList));
          this.bankTableData = res.data.crmBankList;
          this.bankTableData2 = JSON.parse(JSON.stringify(res.data.crmBankList));
          this.remark = res.data.tradeCrm.remark;
        } else {
          this.$Message['error']({
            background: true,
            content: res.msg
          });
        }
      });
    },
    search () {
      if (!this.isPoneAvailable(this.phone)) {
        this.$Message['error']({
          background: true,
          content: '请输入正确有效的手机号'
        });
        return;
      }
      var session = JSON.parse(localStorage['session']);
      let data = {
        sessionId: session.sessionId,
        userId: session.userId,
        modeCode: 'SRPl9t65wlnzYjcQruqFV4vz4jghn39v',
        buyerPhone: this.phone
      };
      this.$http.post(data).then((res) => {
        if (res.code == 1) {
          this.buyerName = res.data.buyerName;
          this.id = res.data.id;
        } else {
          this.$Message['error']({
            background: true,
            content: res.msg
          });
        }
      });
    },
    getPage (index, keyword = '') {
      this.loading1 = true;
      let session = JSON.parse(localStorage['session']);
      let data = {
        sessionId: session.sessionId,
        userId: session.userId,
        modeCode: 'tnlOl9ygOYiM44J7tMMX3GLxpcIJW5bP',
        keyword: keyword,
        pageIndex: index,
        pageSize: this.pageSize
      };
      this.$http.post(data).then((res) => {
        this.loading1 = false;
        if (res.code == 1) {
          this.total = res.count;
          this.tableData = res.result_ctn;
        } else {
          this.$Message['error']({
            background: true,
            content: res.msg
          });
        }
      });
    },
    addUserInfo () {
      const session = JSON.parse(localStorage['session']);
      let data = {
        sessionId: session.sessionId,
        userId: session.userId,
        modeCode: 'QBq3QRwE8hV2cj80do1VGT7GLiTPtunL',
        buyerId: this.id,
        remark: this.remark,
        oreList: this.oreTableData2,
        bankList: this.bankTableData2
      };
      this.subLoading = true;
      this.$http.post(data).then((res) => {
        this.subLoading = false;
        if (res.code == 1) {
          this.total = res.count;
          this.tableData = res.result;
          this.manage();
        } else {
          this.$Message['error']({
            background: true,
            content: res.msg
          });
        }
      });
    },
    editUserInfo () {
      var session = JSON.parse(localStorage['session']);
      let data = {
        sessionId: session.sessionId,
        userId: session.userId,
        modeCode: 'jZ28zEhXnnLPOz3wXdZrPC8JmzwfKSXQ',
        id: this.id,
        remark: this.remark,
        oreList: this.oreTableData2,
        bankList: this.bankTableData2
      };
      this.subLoading = true;
      this.$http.post(data).then((res) => {
        this.subLoading = false;
        if (res.code == 1) {
          this.total = res.count;
          this.tableData = res.result;
          this.manage();
        } else {
          this.$Message['error']({
            background: true,
            content: res.msg
          });
        }
      });
    },
    handleChange (daterange) {
      this.value2 = daterange;
      if (this.select1 == '矿种日志') {
        this.getLogInfo(1);
      } else {
        this.getLogInfo2(1);
      }
    }
  },
  created () {
    this.getPage(1);
    this.getSelect();
  }
};
</script>

<style lang="less" scoped>
.renzh {
  width: 980px;
  height: 100%;
  background: #ffffff;
  box-shadow: 0 0 4px 0 rgba(0, 0, 0, 0.1);
  border-radius: 10px;
  margin-left: 20px;
  background: #f9fafc;
  position: relative;

  .manage {
    width: 980px;
    min-height: 540px;
    text-align: center;
    box-shadow: 0 0 4px 0 rgba(0, 0, 0, 0.1);
    border-radius: 10px;
    background: #f9fafc;
    position: relative;

    .top-box {
      background-image: linear-gradient(180deg, #ffffff 0%, #e8e9ea 100%);
      border-radius: 10px 10px 0 0;
      width: 100%;
      height: 40px;

      & > div {
        height: 100%;
        width: 928px;
        margin: 0 auto;
      }

      .title-label {
        width: 4px;
        height: 14px;
        background: #2c59c3;
      }

      .title {
        font-family: PingFangSC-Semibold;
        font-size: 16px;
        color: #2c59c3;
        letter-spacing: 0.4px;
        margin-left: 6px;
      }

      .addOrg {
        background-image: linear-gradient(180deg, #b4ec51 0%, #429321 100%);
        border: 1px solid #4c9b25;
        border-radius: 6px;
        width: 110px;
        height: 30px;
        cursor: pointer;

        &:hover {
          background-image: linear-gradient(180deg, #c4ff5b 0%, #4aa824 100%);
        }

        img {
          width: 14px;
          height: 14px;
          margin-right: 5px;
        }

        .btn {
          font-family: PingFangSC-Regular;
          font-size: 14px;
          color: #ffffff;
          letter-spacing: 0.35px;
          cursor: pointer;
        }
      }
      .addOrg-red {
        width: 110px;
        height: 30px;
        background-image: linear-gradient(180deg, #f5515f 0%, #9f041b 100%);
        border: 1px solid #d0021b;
        border-radius: 6px;
        cursor: pointer;
        margin-right: 10px;

        &:hover {
          background-image: linear-gradient(180deg, #ff7d89 0%, #b4051f 100%);
          border: 1px solid #af1228;
        }

        img {
          width: 14px;
          height: 14px;
          margin-right: 5px;
        }

        .btn {
          font-family: PingFangSC-Regular;
          font-size: 14px;
          color: #ffffff;
          letter-spacing: 0.35px;
        }
      }
    }

    .search-box {
      height: 74px;
      background-color: #f2f3f5;

      .input {
        margin: 0 10px 0 26px;
      }

      .btn {
        background-image: linear-gradient(180deg, #91caff 0%, #0074d6 97%);
        border: 1px solid #006bc4;
        border-radius: 6px;
        width: 80px;
        height: 30px;
        line-height: 30px;
        text-align: center;
        font-family: PingFangSC-Regular;
        font-size: 14px;
        color: #ffffff;
        letter-spacing: 0.35px;
        cursor: pointer;

        &:hover {
          background-image: linear-gradient(180deg, #cce7ff 0%, #027de6 97%);
        }
      }
    }

    .table-box {
      background: #ffffff;
      box-shadow: 0 0 4px 0 rgba(0, 0, 0, 0.1);
      border-radius: 10px;
      border-radius: 10px;
      min-height: 534px;
      overflow: hidden;

      .table {
        width: 928px;
        margin: 25px auto;

        /deep/.ivu-table-cell {
          padding-left: 12px;
          overflow: unset;
        }

        .icon-box:hover {
          color: #4a90e2 !important;
        }

        .icon-box {
          & > div {
            margin-right: 11px;
            position: relative;
            cursor: pointer;
          }

          .tips {
            position: absolute;
            left: 10px;
            top: -10px;
            width: 30px;
            height: 15px;
            line-height: 15px;
            font-family: PingFangSC-Regular;
            font-size: 12px;
            background-color: #ffffff;
            color: #9b9b9b;
            letter-spacing: 0;
          }

          .tips2 {
            left: -10px;
          }
        }

        .delete {
          margin-left: 14px;
        }

        .edit,
        .delete {
          color: #4a4a4a;
        }

        .edit:hover,
        .delete:hover {
          color: #4a90e2 !important;
        }

        .item {
          margin-left: 4px;
          font-family: PingFangSC-Regular;
          font-size: 14px;
          letter-spacing: 0;
        }
      }
    }
  }

  & > .item {
    width: 980px;
    min-height: 1000px;
    background: #ffffff;
    box-shadow: 0 0 4px 0 rgba(0, 0, 0, 0.1);
    border-radius: 10px;
    position: relative;

    .top {
      .addr {
        width: 14px;
        height: 18px;
        margin: 15px;
        margin-right: 8px;
      }

      .title {
        font-family: PingFangSC-Regular;
        font-size: 14px;
        color: #adb2bc;
        letter-spacing: 0.26px;
        cursor: pointer;
      }

      .arrow {
        width: 7px;
        height: 14px;
        margin: 0 10px;
      }
    }

    .content {
      width: 860px;

      .input-box {
        .star {
          font-size: 10px;
          color: red;
        }

        .label {
          font-family: PingFangSC-Semibold;
          font-size: 14px;
          color: #9097a9;
          letter-spacing: 0.26px;
          line-height: 20px;
          margin: 8px 10px;
        }

        input,
        /deep/.ivu-input {
          width: 368px;
          height: 48px;
          // background: #F5F7FA;
          border-radius: 8px;
          padding-left: 24px;
          font-size: 14px;
        }

        .adduser {
          background: #ffffff;
          // border: 1px solid #DFDFDF;
          box-shadow: inset 0 4px 8px 0 rgba(0, 0, 0, 0.07);
          border-radius: 8px;
          font-size: 14px;
        }
      }

      .split-line {
        height: 1px;
        width: 860px;
        border: 1px dashed #ebedf3;
        margin: 20px 0 25px 0;
      }

      .org-info {
        /deep/.ivu-table-tip {
          overflow-x: hidden;
        }

        .icon-box:hover {
          color: #4a90e2 !important;
          cursor: pointer;
        }

        .top {
          margin-bottom: 10px;

          .label {
            width: 4px;
            height: 14px;
            background: #2c59c3;
          }

          .title {
            font-family: PingFangSC-Semibold;
            font-size: 16px;
            color: #2c59c3;
            letter-spacing: 0.4px;
            margin: 0 14px 0 6px;
          }

          .subtitle {
            font-family: PingFangSC-Regular;
            font-size: 12px;
            color: #af2534;
          }

          .btn-box {
            background-image: linear-gradient(180deg, #b4ec51 0%, #429321 100%);
            border: 1px solid #4c9b25;
            border-radius: 6px;
            width: 110px;
            height: 30px;
            cursor: pointer;

            &:hover {
              background-image: linear-gradient(
                180deg,
                #c4ff5b 0%,
                #4aa824 100%
              );
            }

            img {
              margin-right: 10px;
            }

            .btn {
              font-family: PingFangSC-Regular;
              font-size: 14px;
              color: #ffffff;
              letter-spacing: 0.35px;
              cursor: pointer;
            }
          }
        }

        .edit {
          margin-right: 10px;
        }

        .del-icon:hover,
        .edit-icon:hover {
          color: #4a90e2 !important;
        }

        .del {
          font-family: PingFangSC-Regular;
          font-size: 14px;
          color: #4a4a4a;
          letter-spacing: 0;
          margin-left: 5px;
        }
      }

      .remark-box {
        .label {
          font-family: PingFangSC-Semibold;
          font-size: 14px;
          color: #9097a9;
          letter-spacing: 0.26px;
          margin: 20px 0 8px 0;
        }

        /deep/ textarea.ivu-input {
          height: 100px;
          background: #ffffff;
          // border: 1px solid #DFDFDF;
          box-shadow: inset 0 4px 8px 0 rgba(0, 0, 0, 0.07);
          border-radius: 8px;
          resize: none;
        }
      }

      .bottom-btn-box {
        & > div,
        button {
          width: 160px;
          height: 40px;
          line-height: 40px;
          border-radius: 4px;
          font-family: PingFangSC-Semibold;
          font-size: 18px;
          color: #ffffff;
          letter-spacing: 0.34px;
          text-align: center;
          margin-top: 50px;
        }

        .cancel {
          background-image: linear-gradient(180deg, #f5515f 0%, #9f041b 100%);
          border: 1px solid #af1228;
          cursor: pointer;

          &:hover {
            background-image: linear-gradient(180deg, #ff7d89 0%, #b4051f 100%);
          }
        }

        .save {
          margin-left: 40px;
          background-image: linear-gradient(180deg, #478ee9 0%, #2255ce 100%);
          border: 1px solid #285ed3;
          cursor: pointer;

          &:hover {
            background-image: linear-gradient(180deg, #5295f5 0%, #2559d1 99%);
          }
        }
      }

      .filter {
        margin-bottom: 14px;

        .label {
          font-family: PingFangSC-Regular;
          font-size: 14px;
          color: #616c84;
          margin: 0 10px 0 26px;

          &:first-child {
            margin-left: 0;
          }
        }

        /deep/.ivu-date-picker-focused input,
        /deep/.ivu-date-picker-focused input {
          font-size: 14px;
        }

        /deep/.ivu-select-selected-value,
        /deep/.ivu-select-item {
          text-align: start;
        }

        /deep/ .ivu-select-selection {
          width: 140px;
          height: 38px;
          line-height: 38px;
          border-radius: 8px;
          padding-left: 24px;
          background: #ffffff;
          // border: 1px solid #CCD1DD;
          box-shadow: inset 0 2px 4px 0 rgba(0, 0, 0, 0.17);
          border-radius: 8px;
        }

        /deep/ .ivu-select-placeholder,
        /deep/.ivu-select-selected-value {
          line-height: 38px;
          padding-left: 0;
        }

        /deep/.ivu-date-picker-focused input,
        /deep/.ivu-date-picker-focused input {
          font-size: 14px;
        }

        /deep/.ivu-input-with-suffix {
          cursor: pointer;
        }

        /deep/.ivu-input-suffix {
          line-height: 38px;
        }

        /deep/.ivu-input-with-suffix {
          height: 38px;
          line-height: 38px;
          padding-left: 24px;
          background: #ffffff;
          // border: 1px solid #DFDFDF;
          box-shadow: inset 0 4px 8px 0 rgba(0, 0, 0, 0.07);
          border-radius: 8px;
        }
      }
    }
  }

  .mask {
    width: 100vw;
    height: 100vh;
    background: rgba(0, 0, 0, 0.6);
    position: fixed;
    top: 0;
    left: 0;
    z-index: 10;

    .pop1-box {
      position: absolute;
      width: 480px;
      height: 560px;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
      z-index: 2;

      .top {
        width: 100%;
        height: 46px;
        background-image: linear-gradient(180deg, #5792e3 0%, #2c59c3 100%);
        border-radius: 10px 10px 0 0;

        .title {
          font-family: PingFangSC-Semibold;
          font-size: 18px;
          color: #ffffff;
          letter-spacing: 0.34px;
        }

        img {
          position: absolute;
          float: right;
          width: 16px;
          height: 16px;
          right: 15px;
          cursor: pointer;
        }
      }

      .content {
        width: 100%;
        height: 270px;
        background: #fff;
        overflow: hidden;

        .item {
          width: 368px;
          height: 405px;
          margin-top: 8px;
          margin-left: 56px;

          input:disabled {
            background: #f5f7fa;
            border: 1px solid rgba(118, 118, 118, 0.3);
            box-shadow: none;
          }

          .name-input {
            width: 368px;
            height: 48px;
            background: #f5f7fa;
            border-radius: 8px;
            padding-left: 24px;
          }

          .price-input {
            background: #ffffff;
            // border: 1px solid #dfdfdf;
            box-shadow: inset 0 4px 8px 0 rgba(0, 0, 0, 0.07);
            border-radius: 8px;
            width: 316px;
            height: 48px;
            font-size: 16px;
          }

          /deep/.ivu-input {
            box-shadow: inset 0 4px 8px 0 rgba(0, 0, 0, 0.07);
            border-radius: 8px;
            width: 316px;
            height: 48px;
            padding-left: 24px;
            font-size: 16px;
          }

          .explain {
            font-family: PingFangSC-Regular;
            font-size: 12px;
            color: #af2534;
          }

          .unit {
            font-family: PingFangSC-Regular;
            font-size: 16px;
            color: #4a4a4a;
            letter-spacing: 0.3px;
            margin-left: 10px;
          }

          .title-box {
            margin: 14px 0 8px 0;

            span {
              color: #d0021b;
              margin-right: 5px;
            }

            /deep/ .ivu-radio-wrapper {
              font-family: PingFangSC-Regular;
              font-size: 16px;
              color: #4a4a4a;
              letter-spacing: 0.3px;
            }

            /deep/.ivu-radio {
              margin-left: 30px;
            }

            .title {
              font-family: PingFangSC-Semibold;
              font-size: 16px;
              color: #9097a9;
              letter-spacing: 0.3px;
              line-height: 22px;
              width: 100px;
            }
          }

          .remark {
            background: #ffffff;
            // border: 1px solid #dfdfdf;
            box-shadow: inset 0 4px 8px 0 rgba(0, 0, 0, 0.07);
            border-radius: 8px;
            width: 368px;
            height: 140px;
            padding: 14px !important;
            resize: none;
          }
        }

        /deep/ .ivu-select-selection {
          width: 368px;
          height: 48px;
          line-height: 48px;
          border-radius: 8px;
          padding-left: 24px;
          background: #ffffff;
          // border: 1px solid #DFDFDF;
          box-shadow: inset 0 4px 8px 0 rgba(0, 0, 0, 0.07);
        }

        /deep/ .ivu-select-placeholder,
        /deep/ .ivu-select-placeholder,
        /deep/.ivu-select-selected-value {
          line-height: 48px;
          padding-left: 0;
          height: 48px;
        }
      }
      .question-content {
        height: 80px;
        background: #fff;
        font-size: 20px;
        text-align: center;
        line-height: 80px;
      }
      .bottom {
        // transform: scaleY(-1);
        background: #f5f5f5;
        border-radius: 0 0 10px 10px;
        height: 50px;

        .cancel {
          width: 138px;
          height: 30px;
          line-height: 30px;
          background-image: linear-gradient(
            180deg,
            rgba(255, 255, 255, 0.97) 0%,
            rgba(251, 251, 251, 0.98) 37%,
            #f5f5f5 100%
          );
          border: 1px solid #cacaca;
          border-radius: 4px;
          font-family: PingFangSC-Medium;
          font-size: 14px;
          color: #000000;
          letter-spacing: 0;
          text-align: center;
          cursor: pointer;

          &:hover {
            background-image: linear-gradient(
              180deg,
              rgba(255, 255, 255, 0.97) 0%,
              rgba(251, 251, 251, 0.98) 37%,
              #e9e9e9 100%
            );
          }
        }

        .save {
          width: 138px;
          height: 30px;
          line-height: 30px;
          background-image: linear-gradient(180deg, #478ee9 0%, #2255ce 100%);
          border: 1px solid #285ed3;
          border-radius: 4px;
          font-family: PingFangSC-Medium;
          font-size: 14px;
          color: #ffffff;
          letter-spacing: 0;
          margin-left: 16px;
          text-align: center;
          cursor: pointer;

          &:hover {
            background-image: linear-gradient(180deg, #5295f5 0%, #2559d1 99%);
          }
        }
      }
    }

    .pop2-box {
      width: 480px;
      height: 282px;
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
      z-index: 2;

      .top {
        width: 100%;
        height: 46px;
        background-image: linear-gradient(180deg, #5792e3 0%, #2c59c3 100%);
        border-radius: 10px 10px 0 0;

        .title {
          font-family: PingFangSC-Semibold;
          font-size: 18px;
          color: #ffffff;
          letter-spacing: 0.34px;
        }

        img {
          position: absolute;
          float: right;
          width: 16px;
          height: 16px;
          right: 15px;
          cursor: pointer;
        }
      }

      .content {
        width: 100%;
        height: 186px;
        background-color: #ffffff;
        font-family: PingFangSC-Medium;
        font-size: 16px;
        color: #4a4a4a;
        letter-spacing: 0;
      }

      .bottom {
        // transform: scaleY(-1);
        background: #f5f5f5;
        border-radius: 0 0 10px 10px;
        height: 50px;

        .cancel {
          width: 138px;
          height: 30px;
          line-height: 30px;
          background-image: linear-gradient(
            180deg,
            rgba(255, 255, 255, 0.97) 0%,
            rgba(251, 251, 251, 0.98) 37%,
            #f5f5f5 100%
          );
          border: 1px solid #cacaca;
          border-radius: 4px;
          font-family: PingFangSC-Medium;
          font-size: 14px;
          color: #000000;
          letter-spacing: 0;
          margin-left: 16px;
          text-align: center;
          cursor: pointer;

          &:hover {
            background-image: linear-gradient(
              180deg,
              rgba(255, 255, 255, 0.97) 0%,
              rgba(251, 251, 251, 0.98) 37%,
              #e9e9e9 100%
            );
          }
        }

        .save {
          width: 138px;
          height: 30px;
          line-height: 30px;
          background-image: linear-gradient(180deg, #478ee9 0%, #2255ce 100%);
          border: 1px solid #285ed3;
          border-radius: 4px;
          font-family: PingFangSC-Medium;
          font-size: 14px;
          color: #ffffff;
          letter-spacing: 0;
          text-align: center;
          cursor: pointer;

          &:hover {
            background-image: linear-gradient(180deg, #5295f5 0%, #2559d1 99%);
          }
        }
      }
    }

    .pop3-box {
      position: absolute;
      width: 480px;
      height: 414px;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
      z-index: 11;
      background: #ffffff;
      box-shadow: 0 0 20px 0 rgba(0, 0, 0, 0.04),
        0 20px 31px 0 rgba(0, 0, 0, 0.16);
      border-radius: 10px;

      .top {
        width: 100%;
        height: 46px;
        background-image: linear-gradient(180deg, #5792e3 0%, #2c59c3 100%);
        border-radius: 10px 10px 0 0;

        .title {
          font-family: PingFangSC-Semibold;
          font-size: 18px;
          color: #ffffff;
          letter-spacing: 0.34px;
        }

        img {
          position: absolute;
          float: right;
          width: 16px;
          height: 16px;
          right: 15px;
          cursor: pointer;
        }
      }

      .content {
        background-color: #ffffff;
        width: 100%;
        height: 300px;
        border-radius: 10px;

        .item {
          width: 368px;
          margin-top: 24px;
          margin-left: 56px;

          /deep/ .bank-select input:hover {
            border: none;
            box-shadow: none;
          }

          .name-input {
            width: 368px;
            height: 48px;
            border-radius: 8px;
            // padding-left: 24px;
            background: #ffffff;
            // border: 1px solid #DFDFDF;
            box-shadow: inset 0 4px 8px 0 rgba(0, 0, 0, 0.07);
            font-size: 16px;
          }

          /deep/.ivu-input {
            width: 368px;
            height: 48px;
            border-radius: 8px;
            padding-left: 24px;
            background: #ffffff;
            box-shadow: inset 0 4px 8px 0 rgba(0, 0, 0, 0.07);
            font-size: 16px;
          }

          /deep/ .ivu-select-selection {
            width: 368px;
            height: 48px;
            line-height: 48px;
            border-radius: 8px;
            padding-left: 24px;
            background: #ffffff;
            // border: 1px solid #DFDFDF;
            box-shadow: inset 0 4px 8px 0 rgba(0, 0, 0, 0.07);
          }

          /deep/ .ivu-select-placeholder,
          /deep/ .ivu-select-placeholder,
          /deep/.ivu-select-selected-value {
            line-height: 48px;
            height: 48px;
            padding-left: 0;
          }

          .explain {
            font-family: PingFangSC-Regular;
            font-size: 12px;
            color: #af2534;
          }

          .unit {
            font-family: PingFangSC-Regular;
            font-size: 16px;
            color: #4a4a4a;
            letter-spacing: 0.3px;
            margin-left: 10px;
          }

          .title-box {
            margin: 14px 0 8px 0;

            span {
              color: #d0021b;
              margin-right: 5px;
            }

            /deep/ .ivu-radio-wrapper {
              font-family: PingFangSC-Regular;
              font-size: 16px;
              color: #4a4a4a;
              letter-spacing: 0.3px;
            }

            /deep/.ivu-radio {
              margin-left: 30px;
            }

            .title {
              font-family: PingFangSC-Semibold;
              font-size: 16px;
              color: #9097a9;
              letter-spacing: 0.3px;
              line-height: 22px;
              width: 100px;
            }
          }

          .remark {
            background: #ffffff;
            // border: 1px solid #dfdfdf;
            box-shadow: inset 0 4px 8px 0 rgba(0, 0, 0, 0.07);
            border-radius: 8px;
            width: 368px;
            height: 140px;
            padding: 14px !important;
            resize: none;
          }
        }
      }

      .bottom {
        // transform: scaleY(-1);
        background: #f5f5f5;
        border-radius: 0 0 10px 10px;
        height: 50px;

        .cancel {
          width: 138px;
          height: 30px;
          line-height: 30px;
          background-image: linear-gradient(
            180deg,
            rgba(255, 255, 255, 0.97) 0%,
            rgba(251, 251, 251, 0.98) 37%,
            #f5f5f5 100%
          );
          border: 1px solid #cacaca;
          border-radius: 4px;
          font-family: PingFangSC-Medium;
          font-size: 14px;
          color: #000000;
          letter-spacing: 0;
          text-align: center;
          cursor: pointer;

          &:hover {
            background-image: linear-gradient(
              180deg,
              rgba(255, 255, 255, 0.97) 0%,
              rgba(251, 251, 251, 0.98) 37%,
              #e9e9e9 100%
            );
          }
        }

        .save {
          width: 138px;
          height: 30px;
          line-height: 30px;
          background-image: linear-gradient(180deg, #478ee9 0%, #2255ce 100%);
          border: 1px solid #285ed3;
          border-radius: 4px;
          font-family: PingFangSC-Medium;
          font-size: 14px;
          color: #ffffff;
          letter-spacing: 0;
          margin-left: 16px;
          text-align: center;
          cursor: pointer;

          &:hover {
            background-image: linear-gradient(180deg, #5295f5 0%, #2559d1 99%);
          }
        }
      }
    }
  }

  /deep/.ivu-table-wrapper-with-border {
    border-radius: 12px;
  }

  // /deep/ .ivu-table:before {
  //     background-color: transparent !important;
  // }

  // /deep/ .ivu-table:after {
  //     background-color: transparent !important;
  // }

  /deep/ .ivu-table th {
    background-image: linear-gradient(180deg, #2f66ba 0%, #153684 100%);
    color: #fff;
  }

  /deep/ .ivu-table th:first-child {
    border-top-left-radius: 10px;
    background-image: linear-gradient(180deg, #2f66ba 0%, #153684 100%);
    color: #fff;
  }

  /deep/ .ivu-table th:last-child {
    border-top-right-radius: 10px;
    background-image: linear-gradient(180deg, #2f66ba 0%, #153684 100%);
    color: #fff;
  }

  /deep/.ivu-select-selected-value,
  /deep/.ivu-select-item {
    text-align: start;
    border-bottom: 1px solid #fafafa;
  }

  /deep/span.ivu-select-selected-value {
    border-bottom: none;
  }

  /deep/.ivu-select-item:last-child {
    border-bottom: none;
  }

  /deep/.ivu-radio-inner:after {
    background-color: #2c59c3;
  }

  /deep/.ivu-radio-checked .ivu-radio-inner {
    border-color: #2c59c3;
  }

  /deep/.ivu-table-stripe .ivu-table-body tr:nth-child(2n) td,
  .ivu-table-stripe .ivu-table-fixed-body tr:nth-child(2n) td {
    background-color: rgba(236, 241, 247, 0.4);
  }

  /deep/.ivu-table-stripe .ivu-table-body tr.ivu-table-row-hover td,
  .ivu-table-stripe .ivu-table-fixed-body tr.ivu-table-row-hover td {
    background: rgba(255, 255, 235, 0.15) !important;
  }

  /deep/.ivu-table-row-hover {
    background: rgba(255, 255, 235, 0.15) !important;
  }

  /deep/.ivu-input-with-suffix {
    box-shadow: inset 0 2px 4px 0 rgba(0, 0, 0, 0.07);
  }

  /deep/.ivu-table-wrapper-with-border {
    border-radius: 12px;
    border: 1px solid #dcdee2;
    border-right: none;
  }

  /deep/.ivu-table td,
  .ivu-table th {
    border-bottom: none;
  }

  /deep/.ivu-table:before {
    display: none;
  }

  input:disabled {
    background: #f5f7fa;
    border: 1px solid rgba(118, 118, 118, 0.3);
    box-shadow: none;
  }

  /deep/.ivu-input[disabled] {
    color: #000;
  }

  /deep/.ivu-table-tip {
    overflow-x: hidden;
  }
}
</style>
